<svg class="stage-svg" [attr.viewBox]="'0 0 ' + VIEW_W + ' ' + VIEW_H" preserveAspectRatio="xMidYMid meet">
  <defs>
    <radialGradient id="pb-panel" cx="50%" cy="34%" r="75%">
      <stop offset="0%" stop-color="#231a52" /><stop offset="55%" stop-color="#120d33" /><stop offset="100%" stop-color="#070518" />
    </radialGradient>
    <radialGradient id="pb-orb" cx="38%" cy="32%" r="72%">
      <stop offset="0%" stop-color="#ffffff" /><stop offset="35%" stop-color="#8fd6ff" /><stop offset="100%" stop-color="#3a6cff" />
    </radialGradient>
    <radialGradient id="pb-core" cx="40%" cy="34%" r="70%">
      <stop offset="0%" stop-color="#fff7d6" /><stop offset="40%" stop-color="#ffd36a" /><stop offset="100%" stop-color="#ff7a3c" />
    </radialGradient>
    <linearGradient id="pb-card" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="rgba(120,150,255,0.14)" /><stop offset="100%" stop-color="rgba(70,90,180,0.08)" />
    </linearGradient>
    <filter id="pb-glow" x="-80%" y="-80%" width="260%" height="260%">
      <feGaussianBlur stdDeviation="5" result="b" /><feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
    </filter>
  </defs>

  <!-- panel + stars -->
  <rect x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" fill="url(#pb-panel)" />
  <g class="stars" fill="#dbe8ff">
    <circle cx="140" cy="90" r="2" class="s1" /><circle cx="850" cy="70" r="1.6" class="s2" /><circle cx="720" cy="150" r="1.8" class="s3" />
    <circle cx="240" cy="180" r="1.5" class="s1" /><circle cx="900" cy="220" r="2" class="s2" /><circle cx="120" cy="250" r="1.6" class="s3" />
    <circle cx="600" cy="60" r="1.5" class="s1" /><circle cx="430" cy="120" r="1.4" class="s2" />
  </g>

  <!-- reactor core (before the blast) -->
  <g *ngIf="!solvedState" class="seed" [attr.transform]="'translate(' + RX + ',' + RY + ')'">
    <circle class="seed-halo" r="46" />
    <circle class="seed-core" r="24" fill="url(#pb-core)" />
    <text class="seed-x" x="0" y="2" text-anchor="middle" dominant-baseline="central">⚡</text>
  </g>

  <!-- chain-reaction burst -->
  <g *ngIf="solvedState" class="burst">
    <circle class="flash" [attr.cx]="RX" [attr.cy]="RY" r="30" />
    <circle *ngFor="let o of blastOrbs" class="borb" [attr.cx]="o.x" [attr.cy]="o.y" [attr.r]="o.r"
            fill="url(#pb-orb)" [style.animation-delay.ms]="o.delay" />
  </g>

  <!-- answer orbs -->
  <g *ngFor="let c of cards; let i = index" class="card"
     [class.correct]="isChosen(i)" [class.wrong]="isWrong(i)" (click)="onCard(i)">
    <rect class="card-bg" [attr.x]="c.x - 78" [attr.y]="CARD_Y - 38" width="156" height="76" rx="18" fill="url(#pb-card)" />
    <text class="card-text" [attr.x]="c.x" [attr.y]="CARD_Y + 2" text-anchor="middle" dominant-baseline="central">{{ c.value }}</text>
  </g>
</svg>
